import * as React from 'react';
import {
	Create,
	CreateProps,
	ReferenceArrayInput,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { CustomFileInput } from '../components/CustomFileInput';
import { ELanguage } from '../enums';

export const DynamicCardCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<UploadImage step={1} source="imageUrl" label="IMAGE"/>
				<TextInput step={1} source="name" label="NAME"/>
				<TextInput type="url" step={1} source="link" label="LINK"/>
				<CustomFileInput step={1} source="link" label="FILE"/>
				<ReferenceArrayInput
					step={1}
					label="TAGS"
					source="tagsIds" // this should match the field name in your API
					reference="tags" // this should match the endpoint for tags in your API
				>
					<SelectArrayInput optionText="title" />
				</ReferenceArrayInput>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
